module.exports = __webpack_public_path__ + "img/export.9b13123d.png";